import React, { useState, useEffect, useCallback } from "react";
import { Typography, Button, TextField, Grid } from "@mui/material";
import useStyles from "./style";
import { useFormik } from "formik";
import * as yup from "yup";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom'
import _ from "lodash";
import MenuItem from "@mui/material/MenuItem";

//Api routes
import settingsApi from "Services/Settings";
import locationApi from "Services/Location";
import countryCodeData from "./data/index.json";

//Google maps
import MapContainer from "./GoogleMaps";
import { Label } from "@mui/icons-material";
import GoogleMapLoader from "../../../Googlemaploader";

const AddLocation = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
const navigate = useNavigate();
  // States
  const [values, setValues] = useState([]);
  const [shapesDeleted, setShapesDeleted] = useState(0);
  const [polygonData, setPolygonData] = useState([]);

  //

  const handleAddLocations = (formValues) => {
    //dispatch(showLoader("Loading please wait..."));

    const data = {
      locationName: formValues?.locationName,
      countryId: formValues?.country,
      polygonData: polygonData,
    };
 
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Add location successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik?.resetForm();
        setValues(null);
        getMasterValues();
        navigate('/list-location');
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while add locations",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("settings value update api", err);
    };

    if (polygonData != "") {
      locationApi.addServiceArea({ ...data }).then(onSuccess, onFailure);
    } else {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Location data cannot be empty",
          autoHideDuration: 6000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "warning",
        })
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      locationName: "",
      country: "",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      locationName: yup
        .string()
        .required("location Name is required")
        .trim()
        .min(3, "Name must be atleast 3 letters")
        .max(50, "Max 50 characters are allowed")
        .nullable(),
    }),
    onSubmit: handleAddLocations,
  });

  // Get Business Settings
  const getMasterValues = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setValues(res?.data?.data);
      } else {
        setValues([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.getBusinessSettings().then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    getMasterValues();
  }, [getMasterValues]);

  // Formik - Set fetched values for master
  useEffect(() => {
    if (!_.isEmpty(values)) {
      //console.log("values ", values);
    }
  }, [values]);

  //Maps

  const handleDeleteShapes = () => {
    setShapesDeleted((prevCount) => prevCount + 1);
  };

  const handlePolygonChange = (newPolygonData) => {
    //console.log("polygonData ", newPolygonData);
    setPolygonData(newPolygonData);
  };

  return (
    <>
      <br></br>
      <br></br>
      <Grid container className={classes.cardContainer}>
        <Grid container xs={12} md={12} lg={12} xl={12}>
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            xl={12}
            className={classes.container}
          >
            <div style={{ padding: "5px 0px" }}>
              <Typography variant="h5">Add Location</Typography>
            </div>
          </Grid>
          <Grid container xs={12} md={12} lg={12} xl={12}>
            <Grid item xs={12} md={4} lg={4} xl={4}>
              {/* Location Name */}
              <Grid
                container
                xs={12}
                md={12}
                lg={12}
                xl={12}
                className={classes.fieldContainerWrapper}
              >
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.fieldContainer}
                >
                  <TextField
                    name="locationName"
                    id="locationName"
                    label="Location Name"
                    value={formik?.values?.locationName}
                    defaultValue={formik?.values?.locationName}
                    onChange={formik?.handleChange}
                    error={
                      formik?.errors?.locationName &&
                      formik?.touched?.locationName
                    }
                    helperText={
                      formik?.errors?.locationName &&
                      formik?.touched?.locationName &&
                      formik?.errors?.locationName
                    }
                    fullWidth
                    variant="outlined"
                    size="small"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.fieldContainer}
                >
                  <TextField
                    name="country"
                    id="country"
                    select
                    label="Country"
                    value={formik?.values?.country}
                    defaultValue={formik?.values?.country}
                    onChange={formik?.handleChange}
                    error={formik?.errors?.country && formik?.touched?.country}
                    helperText={
                      formik?.errors?.country &&
                      formik?.touched?.country &&
                      formik?.errors?.country
                    }
                    fullWidth
                    variant="outlined"
                    size="small"
                  >
{countryCodeData.map((country) => (
                                <MenuItem
                                  key={country.code}
                                  value={country.name}
                                >
                                  {`${country.name}`}
                                </MenuItem>
                              ))}
                  </TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.updateBtn}
                >
                  <Button variant="contained" onClick={formik?.handleSubmit}>
                    Add
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            {/* Map container */}
            <Grid item xs={12} md={8} lg={8} xl={8} style={{ height: "550px" }}>
              <div className={classes.mapContainerStyles}>
                 <GoogleMapLoader>
                <MapContainer
    showDeleteButton={true}
    onDeleteShape={handleDeleteShapes}
    onPolygonChange={handlePolygonChange}
    shapesDeleted={shapesDeleted} // 👈 pass this prop
                />
                </GoogleMapLoader>
              </div>

              <Button
                size="large"
                variant="contained"
                style={{ padding: "8px", fontSize: "12px" }}
                onClick={handleDeleteShapes}
              >
                Delete Shapes
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <br></br>
      <br></br>
      <br></br>
    </>
  );
};

export default AddLocation;
